import { executeQueue, selectQueueCount } from '@medlogic/shared/state-queue';
import { MaterialDialogService } from '@medlogic/shared/gecore';
import { StockSyncDialogComponent, ConfigPwaMedLogicService, NavigationPwaService, CardPatientProvider, DadoDALCustom, LocalMsgPtBR, LocalLoginService } from '@medlogic/medlogic-pwa/medlogic-pwa-cuidado-full';
import { IDataBase } from 'jsstore';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { IAppMedlogicState } from '@medlogic/medlogic/medlogic-shared-interfaces';
import { LocalLibService, UnsubscribeOnDestroyAdapter, LogService, GlobalService } from '@medlogic/shared/shared-interfaces';
import { CadastroService, RedisService } from '@medlogic/shared/shared-data-access';
import { TbQueueService, TbKeyValueService, JsStoreService } from '@medlogic/shared/shared-jsstore';
import { Observable } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { UiDialogAlertComponent } from '@medlogic/shared/ui/dialog/ui-dialog-alert';
import { loadPatientsWithMedications, StatesManagementService } from '@medlogic/medlogic/medlogic-state';
import { TimeoutService } from '@medlogic/medlogic/medlogic-data-access';

@Component({
  selector: 'ml-pwa-navigation-view',
  templateUrl: './pwa-navigation-view.component.html',
  styleUrls: ['./pwa-navigation-view.component.css']
})
export class PwaNavigationViewComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  dbName = 'medlogicDb';
  pendingStock$: Observable<number> = this.store.pipe(select(state => selectQueueCount(state.queue)));

  public get pending(): number {
    return this.cnf.pending;
  }

  private _hasMedication = true;
  public get hasMedication(): boolean {
    return this._hasMedication;
  }
  public set hasMedication(v: boolean) {
    this._hasMedication = v;
  }

  private _hasKitchen = true;
  public get hasKitchen(): boolean {
    return this._hasKitchen;
  }
  public set hasKitchen(v: boolean) {
    this._hasKitchen = v;
  }

  public get showMenu(): boolean {
    return this.cnf.showMenu;
  }

  public get saved(): number {
    return this.cnf.saved;
  }

  public get userName(): string {
    return this.cnf.usuarioLogadoNome;
  }

  public get isBtnSyncEnabled(): boolean {
    return this.pending > 0;
  }

  public get isMobile(): boolean {
    return this.glb.isMobile();
  }

  constructor(
    private log: LogService,
    private cadastroSrv: CadastroService,
    public cnf: ConfigPwaMedLogicService,
    private loginSrv: LocalLoginService,
    private glb: GlobalService,
    private snackBar: MatSnackBar,
    private msg: LocalMsgPtBR,
    private jsStoreSrv: JsStoreService,
    private tbQueue: TbQueueService,
    private tbKeyValue: TbKeyValueService,
    private dadoSrv: DadoDALCustom,
    private nav: NavigationPwaService,
    public pv: CardPatientProvider,
    private mat: MaterialDialogService,
    private matDialog: MatDialog,
    private lib: LocalLibService,
    private store: Store<IAppMedlogicState>,
    private redis: RedisService,
    private stateMan: StatesManagementService,
    private timeoutService: TimeoutService,
  ) {
    super();
  }

  ngOnInit() {
    try {
      this.cadastroSrv.updatePending();
      this.startIndexedDb(this.dbName);
      this.subs.sink = this.store.pipe(select(state => {
        this.timeoutService.startMonitoring(state?.tenant?.login?.customerId, () => this.onLogoff());
      })).subscribe();
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'ngOnInit', error.message);
    }
  }

  /* Inicializa o Banco de Dados do tipo IndexedDb. */
  protected startIndexedDb(dbName: string): void {
    try {
      const dbSchema = {
        name: dbName,
        tables: [
          this.tbQueue.getTableSchema(),
        ]
      } as IDataBase;
      this.jsStoreSrv.createDb(dbSchema);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'startIndexedDb', error.message);
    }
  }

  offLineClick(isOffLineMode: boolean): void {
    try {
      if (!isOffLineMode) {
        this.mat.openDialogAlert(
          'Ativação do Modo Offline',
          'Ao ativar esse módulo, todos os dados serão carregados para que fique independente do sinal com a Internet. Quer continuar?'
        ).subscribe(wasConfirmed => {
          if (wasConfirmed) {
            this.pv.isOffLineMode = !isOffLineMode;
            this.nav.gotoCardPatient();
          }
        });
      }
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'offLineClick', error.message);
    }
  }

  /* Click no botão para sincronizar os dados. */
  onSync(): void {
    try {
      if (navigator.onLine) {
        this.openSnackBar(this.msg.SYNC_DATA_BEING_SAVED);
        this.subs.sink = this.cadastroSrv.executeQueue()
          .pipe(
            mergeMap(() => this.dadoSrv.executeQueue()),
            tap(() => {
              this.loginSrv.cleanAllCaches();
              this.nav.gotoLogin();
            })
          ).subscribe();
      } else {
        this.openSnackBar(this.msg.DEVICE_INTERNET_CONECTION_NOT_AVAILABLE);
      }
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onSync', error.message);
    }
  }

  /* Click no botão para sincronizar os dados de estoque. */
  onSyncStock(): void {
    try {
      if (navigator.onLine) {
        this.store.dispatch(executeQueue());
        const width = '100vw';
        const height = '100vh';
        this.matDialog.open(StockSyncDialogComponent, {
          width,
          height,
          id: '',
          minWidth: width,
          maxWidth: width,
          minHeight: height,
          maxHeight: height,
          data: {}
        });
      } else {
        this.openSnackBar(this.msg.DEVICE_INTERNET_CONECTION_NOT_AVAILABLE);
      }
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onSyncStock', error.message);
    }
  }

  /* Sair. Limpará todos os caches, inclusive do Redis.
  * TODO: No futuro, ao invés de limpar o cache no logoff e login,
  * receber as atualizações via websocket.
  */
  onLogoff(): void {
    try {
      this.loginSrv.logoff();
      this.nav.gotoLogin();
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onLogoff', error.message);
    }
  }

  /* Ir para módulo de medicação. */
  onMedication(): void {
    try {
      this.nav.gotoMedicationHome(this.cnf.tenantId);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onMedication', error.message);
    }
  }

  /* Ir para módulo de cozinha. */
  onKitchen(): void {
    try {
      this.nav.gotoKitchen(this.cnf.tenantId);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onKitchen', error.message);
    }
  }

  /* Fará a configuração para forçar o comportamento de dispositivos móveis. */
  forceMobile(forceDesktop: boolean): void {
    try {
      this.cnf.isForceMobile = !forceDesktop;
      this.glb.forceMobile = !forceDesktop;
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'forceMobile', error.message);
    }
  }

  /* Checa se o usuário já está logado.  */
  isLogged(): boolean {
    try {
      return !this.glb.isNullOrEmpty(this.cnf.baseUsuarioToken);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'isLogged', error.message);
    }
  }

  /* Exibe a mensagem de offline. */
  protected openSnackBar(message: string): void {
    try {
      this.snackBar.open(message, null, {
        duration: 3000
      });
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'openSnackBar', error.message);
    }
  }

  onFullScreenClick(): void {
    try {
      this.lib.toogleFullscreen();
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onFullScreenClick', error.message);
    }
  }

  onCacheCleanClick(): void {
    try {
      this.subs.sink = this.stateMan.cleanAllStatesAndCache$()
        .subscribe((res: boolean) => {
          const messageHtml = res ? 'Cache removido com sucesso!' : 'Houve falha na tentativa de limpeza do cache';
          const width = '100%';
          const height = '250px';
          this.matDialog
            .open(UiDialogAlertComponent,
              {
                width,
                maxWidth: '520px',
                height,
                data: {
                  title: 'Limpeza de Cache',
                  messageHtml
                }
              });
          this.nav.gotoCardPatient();
          this.store.dispatch(loadPatientsWithMedications());
        });
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onCacheCleanClick', error.message);
    }
  }
}
